// Mock video data
export const videos = [
  {
    id: 1,
    title: "Building Trust with New Clients",
    creator: "Maria Rodriguez",
    thumbnail: "https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?w=640&h=360&fit=crop",
    category: "Relationships",
    youtubeId: "F3gcD4gvXg4"
  },
  {
    id: 2,
    title: "Self-Care for DSPs in a Crisis",
    creator: "James Chen",
    thumbnail: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=640&h=360&fit=crop",
    category: "Wellness",
    youtubeId: "CL95EsnLFuo"
  },
  {
    id: 3,
    title: "Calming & De-escalation Strategies",
    creator: "Sarah Johnson",
    thumbnail: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=640&h=360&fit=crop",
    category: "Skills",
    youtubeId: "R2PSExM-NhU"
  },
  {
    id: 4,
    title: "Let's Talk Burnout - Reclaiming Mental Wellness in Direct Support Work",
    creator: "NADSP — James Baptiste & John Raffaele",
    thumbnail: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=640&h=360&fit=crop",
    category: "Wellness",
    youtubeId: "Re4x60XVvR4"
  },
  {
    id: 5,
    title: "Developmental Disability Direct Support Professional / just say no to acronyms and jargon!",
    creator: "Patricia Williams",
    thumbnail: "https://images.unsplash.com/photo-1511895426328-dc8714191300?w=640&h=360&fit=crop",
    category: "Communication",
    youtubeId: "Q_PVknk6k-o"
  },
  {
    id: 6,
    title: "Supporting Adults with Emotional, Behavioral and Cognitive Differences",
    creator: "Dr. Kevin Lee",
    thumbnail: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=640&h=360&fit=crop",
    category: "Skills",
    youtubeId: "ZRoAff5Q7JM"
  },
  {
    id: 7,
    title: "What Person-Centered Planning Is and Why It's important",
    creator: "Patricia Williams",
    thumbnail: "https://images.unsplash.com/photo-1531545514256-b1400bc00f31?w=640&h=360&fit=crop",
    category: "Skills",
    youtubeId: "mqqq5ICzHQ"
  },
  {
    id: 8,
    title: "TED TALK: Understanding Autism | Brendan Metz",
    creator: "Dr. Anita Patel",
    thumbnail: "https://images.unsplash.com/photo-1491897554428-130a60dd4757?w=640&h=360&fit=crop",
    category: "Education",
    youtubeId: "8jihUBhuqhk"
  },
  {
    id: 9,
    title: "Boundaries Without Burnout",
    creator: "Wellness DSP",
    thumbnail: "https://images.unsplash.com/photo-1499209974431-9dddcece7f88?w=640&h=360&fit=crop",
    category: "Wellness",
    youtubeId: "VZocVwahwDs"
  },
  {
    id: 10,
    title: "Advocating for Your Clients' Rights",
    creator: "Marcus Webb",
    thumbnail: "https://images.unsplash.com/photo-1521791136064-7986c2920216?w=640&h=360&fit=crop",
    category: "Advocacy",
    youtubeId: "N54wS3XzipY"
  },
  {
    id: 11,
    title: "MSD Injury Training for Direct Support Professionals",
    creator: "Public Services Health & Safety Association",
    thumbnail: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=640&h=360&fit=crop",
    category: "Skills",
    youtubeId: "nhxsM1zqz20"
  },
  {
    id: 12,
    title: "Medication Administration Refresher",
    creator: "SafeCare Institute",
    thumbnail: "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=640&h=360&fit=crop",
    category: "Training",
    youtubeId: "H9t-Hy69ZEY"
  },
  {
    id: 13,
    title: "Supporting People with IDD through Grief and Loss | Karyn Harvey",
    creator: "Dr. Lisa Tran",
    thumbnail: "https://images.unsplash.com/photo-1516534775068-ba3e7458af70?w=640&h=360&fit=crop",
    category: "Education",
    youtubeId: "Ac8VYH3uPLE"
  },
  {
    id: 14,
    title: "What is AAC? Basic Overview",
    creator: "SpeechPath Pro",
    thumbnail: "https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=640&h=360&fit=crop",
    category: "Communication",
    youtubeId: "Dw_QaNU_u_k"
  }
];

// Mock community posts
export const communityPosts = [
  {
    id: 1,
    author: "Alex M.",
    role: "DSP - 3 years",
    subject: "Breakthrough moment with a client today",
    content: "Just had the most amazing breakthrough with a client today. Sometimes patience really does pay off! 💙",
    likes: 47,
    comments: 12,
    timestamp: "2h",
    table: { name: 'New DSPs', emoji: '👋', slug: 'new-dsps' },
  },
  {
    id: 2,
    author: "Jordan T.",
    role: "Family DSP",
    subject: "Managing burnout as a full-time family caregiver",
    content: "Looking for advice on managing burnout while supporting my sister full-time. Any tips from those who've been through it? The isolation is the hardest part for me.",
    likes: 23,
    comments: 31,
    timestamp: "4h",
    table: { name: 'Self-Care Strategies', emoji: '🧘', slug: 'self-care-strategies' },
  },
  {
    id: 3,
    author: "Sam R.",
    role: "DSP - 7 years",
    subject: "A reminder for the hard days",
    content: "Reminder: You're doing important work. Even on the hard days. Especially on the hard days.",
    likes: 156,
    comments: 28,
    timestamp: "6h",
    table: { name: 'Self-Care Strategies', emoji: '🧘', slug: 'self-care-strategies' },
  },
  {
    id: 4,
    author: "Priya N.",
    role: "DSP - 2 years",
    subject: "Agency started doing quarterly appreciation lunches",
    content: "My agency just started offering quarterly appreciation lunches for DSPs. Small thing, but it genuinely makes a difference knowing leadership sees the work we do.",
    likes: 89,
    comments: 14,
    timestamp: "9h",
    table: { name: 'Agency Life', emoji: '🏢', slug: 'agency-life' },
  },
  {
    id: 5,
    author: "Marcus W.",
    role: "NADSP Certified - 8 years",
    subject: "Just passed my NADSP recertification — happy to answer questions",
    content: "Passed my NADSP recertification this morning! If anyone's thinking about getting credentialed, I'm happy to share what the process looks like. It changed my career.",
    likes: 201,
    comments: 43,
    timestamp: "1d",
    table: { name: 'Career Growth', emoji: '📈', slug: 'career-growth' },
  },
  {
    id: 6,
    author: "Denise C.",
    role: "Lead DSP - 12 years",
    subject: "Hot take on what makes a great DSP",
    content: "Hot take: de-escalation is a skill you can teach, but the willingness to slow down and actually listen — that's what separates good DSPs from great ones.",
    likes: 312,
    comments: 67,
    timestamp: "1d",
    table: { name: 'Skills & Tips', emoji: '💡', slug: 'skills-and-tips' },
  },
  {
    id: 7,
    author: "Rosa G.",
    role: "Family DSP & Advocate - 6 years",
    subject: "Two things can be true at the same time",
    content: "For all the family caregivers here: you are allowed to grieve the life you imagined while also loving the life you have. Both things are true at the same time.",
    likes: 445,
    comments: 92,
    timestamp: "2d",
    table: { name: 'Family DSP Support', emoji: '❤️', slug: 'family-dsp-support' },
  },
];

// Category options
export const categories = [
  'For You',
  'Skills',
  'Wellness',
  'Inspiration',
  'Family Support',
  'Career'
];

// Explore screen data
export const events = [
  { id: 1, title: 'DSP Networking Mixer', date: '2026-03-19', time: '6:00 PM', location: 'Community Center, Sacramento', type: 'networking' },
  { id: 2, title: 'De-escalation Workshop', date: '2026-03-26', time: '10:00 AM', location: 'Virtual (Zoom)', type: 'training' },
  { id: 3, title: 'Self-Care Saturday', date: '2026-03-01', time: '9:00 AM', location: 'Sunrise Park, Oakland', type: 'wellness' },
  { id: 4, title: 'NADSP Certification Info Session', date: '2026-03-08', time: '2:00 PM', location: 'Virtual (Zoom)', type: 'career' },
  { id: 5, title: 'Family DSP Support Group', date: '2026-03-12', time: '7:00 PM', location: 'Virtual (Google Meet)', type: 'support' },
];

export const mentors = [
  {
    id: 1,
    name: 'Denise Carter',
    role: 'Lead DSP - 12 years',
    specialty: 'Behavioral Support & De-escalation',
    bio: 'I started as a part-time aide and worked my way to lead. I know how overwhelming the first year can be — I want to help new DSPs feel confident and supported.',
    availability: 'Weekday evenings',
    mentees: 3,
    avatar: 'D',
  },
  {
    id: 2,
    name: 'Marcus Williams',
    role: 'NADSP Certified - 8 years',
    specialty: 'Career Growth & Certification Prep',
    bio: 'Got my NADSP credential in 2022 and it changed my career trajectory. Happy to walk anyone through the process and share study tips.',
    availability: 'Weekends',
    mentees: 2,
    avatar: 'M',
  },
  {
    id: 3,
    name: 'Rosa Gutierrez',
    role: 'Family DSP & Advocate - 6 years',
    specialty: 'Family Caregiving & Self-Advocacy',
    bio: 'I care for my adult son full-time. I know the unique challenges family DSPs face — the guilt, the burnout, the isolation. You are not alone.',
    availability: 'Flexible',
    mentees: 4,
    avatar: 'R',
  },
  {
    id: 4,
    name: 'James Okafor',
    role: 'DSP Supervisor - 10 years',
    specialty: 'Documentation & Person-Centered Planning',
    bio: 'Good documentation protects your clients and yourself. I help DSPs build habits that make paperwork feel less like a chore and more like a tool.',
    availability: 'Tue & Thu mornings',
    mentees: 1,
    avatar: 'J',
  },
];
